import React, { useContext, useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  List,
  ListItem,
  Typography,
  Box,
  Alert,
  AlertTitle,
  LinearProgress,
  ListItemText,
  Tooltip,
  Pagination,
  Button,
} from "@mui/material";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { BsArrowLeftCircle } from "react-icons/bs";
import parse from "html-react-parser";
import { Formik } from "formik";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import { openAI } from "../../Components/common/OpenAIComponent";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "react-toastify";
import { appSelector } from "../redux/selector";
import ResumeContext from "./Resumecontext";
import { resumeBuilderSelector } from "./ResumeBuilderActions/selector";
import { setCurrentSection, updateSummaryAction } from "./ResumeBuilderActions/actions";
import CheckIcon from "@mui/icons-material/Check";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
export default function Summary({ setValue, setSelectedSummaries }) {
  const contextObject = useContext(ResumeContext);
  const dispatch = useDispatch();
  const formikRef = useRef();
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [quillContent, setQuillContent] = useState("");
  const [aisummary, setAIsummary] = useState([]);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [copiedIndex, setCopiedIndex] = useState([]);
  const ITEMS_PER_PAGE = 10;
  const { selectedJob } = useSelector(appSelector);
  const { resumeFullDetails } = useSelector(resumeBuilderSelector);

  const handleMouseEnter = (index) => {
    //console.log("index", index);
    setHoveredIndex(index);
    if (isCopied(index)) {
      setHoveredIndex(index);
    }
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  // const handleClick = (index, data) => {
  //   console.log("indexc", index);
  //   handleSummaryClick(data);
  //   if (!copiedIndex.includes(index)) {
  //     navigator.clipboard.writeText(data);
  //     setCopiedIndex([...copiedIndex, index]);
  //     console.log("indexco", [...copiedIndex, index]);
  //   }
  // };

  const handleClick = (index, data) => {
    setCopiedIndex((prevState) => {
      const pageIndexes = prevState[currentPage] || [];
      if (pageIndexes.includes(index)) {
        handleRemoveFromSummary(data);
        return {
          ...prevState,
          [currentPage]: pageIndexes.filter((i) => i !== index),
        };
      } else {
        handleSummaryClick(data);
        // navigator.clipboard.writeText(data);
        return { ...prevState, [currentPage]: [...pageIndexes, index] };
      }
    });
  };
  const { resumedetails = [], projectdetails = [] } = resumeFullDetails || {};
  const Submit = async (values) => {
    //console.log("submit", values);
    if (contextObject.summary?.replace(/<[^>]+>/g, "").trim() === "") {
      toast.warn("Please fill Summary.");
    } else {
      dispatch(updateSummaryAction(quillContent));
      dispatch(setCurrentSection("Project", projectdetails[0]?.id));
      setValue(2);
    }
  };

  const onChange = (content) => {
    //console.log("onChange", content);
    contextObject.updateSummary(content);
    setQuillContent(content);
  };
  const handleSummaryClick = (summarySnippet) => {
    setQuillContent((prevContent) => {
      const trimmed = prevContent.trim();
      return trimmed ? trimmed + " " + summarySnippet : summarySnippet;
    });
    contextObject.updateSummary((prevContent) => {
      const trimmed = (typeof prevContent === 'string' ? prevContent : '').trim();
      return trimmed ? trimmed + " " + summarySnippet : summarySnippet;
    });
    setSelectedSummaries((prevContent) => [...prevContent, summarySnippet]);
  };
  const handleRemoveFromSummary = (summary) => {
    setQuillContent((prevContent) => prevContent.replace(summary, ""));
    contextObject.updateSummary((prevContent) =>
      prevContent.replace(summary, "")
    );
    setSelectedSummaries((prevContent) =>
      prevContent.filter((item) => item !== summary)
    );
  };
  const isCopied = (index) => copiedIndex[currentPage]?.includes(index);

  const paginatedData = aisummary?.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleChangePage = (event, value) => setCurrentPage(value);

  const getAISummary = () => {
    setCopiedIndex([]);
    setSummaryLoading(true);
    let description =
      selectedJob?.job_description &&
      selectedJob?.job_description?.replace(/<(?:.|\n)*?>/gm, "");
    //console.log("summary", description);
    const msg = `Based on the job description below, create a detailed summary highlighting relevant skills, achievements, qualifications, and key expectations that would be valuable for a candidate's resume. Each point should be rephrased with at least 20 words includes at least 30 points to ensure clarity and thoroughness. Focus on information that a candidate would want to showcase in their resume.
    
    Job Description:
    ${description}
    
    Format the output as:
    {
      "summary": [
        "Summary point 1 (at least 20 words)",
        "Summary point 2 (at least 20 words)",
        "Summary point 3 (at least 20 words)",
        ...
        "Summary point 30 (at least 20 words)"
      ]
    }
    
    Ensure each point is directly relevant to a candidate's qualifications and what a potential employer would consider important. Emphasize skills, achievements, and qualities that align with the job requirements.`;

    openAI(msg, (error, results) => {
      if (error) {
        setSummaryLoading(false);
      } else {
        var data = results;
        //console.log("data", data);
        let combinedData = [];
        Object.keys(data).forEach((key) => {
          if (Array.isArray(data[key])) {
            combinedData = [...combinedData, ...data[key]];
          }
        });
        setAIsummary(data?.summary);
        //setCopiedIndex({ [1]: [0, 1, 2, 3, 4] });
        setSummaryLoading(false);
      }
    });
  };
  const handleSummaryOpen = async () => {
    if (selectedJob?.description !== "") {
      setOpen(true);
      await getAISummary();
    } else {
      let msg = "Please enter job title and experience";
      toast.success(msg);
    }
  };

  // useEffect(() => {
  //   handleSummaryOpen();
  // }, []);

  // useEffect(() => {
  //   if (aisummary.length > 0) {
  //     const initialSelectedSummaries = aisummary.slice(0, 5).join("<br>");
  //     setQuillContent(initialSelectedSummaries);
  //     contextObject.updateSummary(initialSelectedSummaries);
  //   }
  // }, [aisummary]);

  const handleSummaryClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (contextObject.summary?.replace(/<[^>]+>/g, "").trim() === "") {
      contextObject.updateSummary(resumeFullDetails?.resumedetails?.summary);
    } else {
      contextObject.updateSummary(contextObject.summary);
    }
  }, []);

  const paperstyles = {
    height: "76vh",
    overflow: "auto",
  };

  const [openJd, setOpenJd] = useState(false);

  const openDialog = () => {
    setOpenJd(true);
  };

  const closeDialog = () => {
    setOpenJd(false);
  };

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          padding: 2,
          border: "1px solid #e6e1e1",
          borderRadius: "10px",
          borderTop: "3px solid #406682",
          boxShadow: "0 0 2px grey",
          backgroundColor: "#fff",
          ...paperstyles,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            my: 1,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="h6"
              sx={{ color: "#406682", fontWeight: "bold" }}
            >
              Professional Summary
            </Typography>
            <Typography sx={{ color: "grey" }}>
              Enhance Your Summary to Align with Job Requirements
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Button
              onClick={openDialog}
              sx={{
                fontSize: "13px",
                padding: "0px 10px",
                height: "30px",
                borderRadius: "22px",
                color: "#406682",
                textTransform: "none",
                backgroundColor: "white",
                cursor: "pointer",
                border: "1px solid #406682",
                transition: "all 0.3s ease-in-out",
                "&:hover": {
                  backgroundColor: "#406682",
                  color: "white",
                },
                mb: 1,
              }}
            >
              Job Description
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleSummaryOpen}
              startIcon={<AddCircleRoundedIcon />}
              sx={{
                cursor: "pointer",
                textTransform: "none",
                borderRadius: "50px",
                width: "170px",
                height: "30px",
                backgroundColor: "#406682",
                color: "white",
                "&:hover": {
                  backgroundColor: "#305165",
                  color: "white",
                },
              }}
            >
              Suggested Phrases
            </Button>
          </Box>
        </Box>

        <Formik
          innerRef={formikRef}
          initialValues={{
            summary: contextObject.summary || "",
          }}
          onSubmit={(values) => {
            //console.log(values);
            Submit();
          }}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Box sx={{ px: "10px" }}>
                <ReactQuill
                  theme="snow"
                  value={contextObject.summary}
                  onChange={onChange}
                />
              </Box>

              <br />

              <Box sx={{ mt: 2 }}>
                <Button
                  variant="contained"
                  // type="submit"
                  size="small"
                  sx={{
                    paddingLeft: "20px",
                    paddingRight: "20px",
                    bgcolor: "#53778e",
                    color: "white",
                    textTransform: "capitalize",
                  }}
                  onClick={() => {
                    setValue(0);
                    //dispatch(IsOpenSummary(false));
                  }}
                >
                  Previous
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  type="submit"
                  sx={{
                    float: "right",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                    bgcolor: "#53778e",
                    color: "white",
                    textTransform: "capitalize",
                  }}
                // onClick={() => setValue(2)}
                >
                  Next
                </Button>
              </Box>
            </form>
          )}
        />
      </Box>
      {open && (
        <Box
          sx={{
            width: "500px",
            height: "410px",
            backgroundColor: "#f9f9f9",
            border: "1px solid #ccc",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            p: 2,
            position: "absolute",
            top: "0",
            right: "0",
            zIndex: 1000,
            left: "102%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {summaryLoading ? (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              mt={2}
              p={5}
            >
              <IconButton
                aria-label="close"
                onClick={handleSummaryClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <AiOutlineCloseCircle />
              </IconButton>
              <Alert
                severity="info"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Box p={3}>
                  <AlertTitle>⏳Summarization in Progress</AlertTitle>
                  Fetching summary from AI. Please wait...
                </Box>
                <LinearProgress style={{ width: "100%" }} />
              </Alert>
            </Box>
          ) : (
            <>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  sx={{
                    mb: 2,
                    fontWeight: "bold",
                    fontSize: "15px",
                    fontFamily: "'Times New Roman', serif !important",
                  }}
                >
                  Showing {aisummary?.length} results for{" "}
                  <span style={{ textTransform: "capitalize" }}>
                    {selectedJob?.jobtitle}
                  </span>
                </Typography>
                <IconButton
                  aria-label="close"
                  onClick={handleSummaryClose}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <AiOutlineCloseCircle />
                </IconButton>
              </Box>

              <Box
                sx={{
                  flexGrow: 1,
                  overflowY: "auto",
                }}
              >
                {paginatedData?.length > 0 ? (
                  <List
                    sx={{
                      fontSize: "12px",
                      //textAlign: "justify",
                    }}
                  >
                    {paginatedData.map((data, index) => (
                      <ListItemText
                        style={{
                          cursor: "pointer",
                          bgcolor: "#eff2f9",
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          {/* Arrow or Tick Icon */}
                          <Tooltip
                            title={isCopied(index) ? "Copied" : "Copy"}
                            open={hoveredIndex === index}
                            arrow
                          >
                            <IconButton
                              size="large"
                              sx={{
                                color: isCopied(index) ? "green" : "inherit",
                                backgroundColor: isCopied(index)
                                  ? "#e0ffe0"
                                  : "aliceblue",
                                borderRadius: "50%",
                                padding: "5px",
                                "&:hover": {
                                  backgroundColor: "#d0d0d0",
                                },
                              }}
                              onMouseEnter={() => handleMouseEnter(index)}
                              onMouseLeave={handleMouseLeave}
                              onClick={() => handleClick(index, data)}
                            //disabled={copiedIndex?.includes(index)}
                            >
                              {isCopied(index) ? (
                                <CheckIcon
                                  sx={{
                                    fontSize: "12px",
                                    color: "green",
                                  }}
                                />
                              ) : (
                                <ArrowBackIcon
                                  sx={{
                                    fontSize: "12px",
                                  }}
                                />
                              )}
                            </IconButton>
                          </Tooltip>

                          {/* Text Content */}
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontFamily: "'Times New Roman' !important",
                            }}
                          >
                            {parse(data)}
                          </Typography>
                        </Box>
                      </ListItemText>
                    ))}
                  </List>
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    <BsArrowLeftCircle size={20} color="lightgrey" />
                    &nbsp;Resume Summary Suggestions
                  </Typography>
                )}
              </Box>
              {/* Pagination Section */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 2,
                }}
              >
                <Pagination
                  count={Math.ceil(aisummary?.length / ITEMS_PER_PAGE)}
                  page={currentPage}
                  onChange={handleChangePage}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                />
              </Box>
            </>
          )}
        </Box>
      )}
      <Dialog
        open={openJd}
        onClose={closeDialog}
        fullWidth
        sx={{ "& .MuiDialog-paper": { width: "750px", maxWidth: "90%" } }}
      >
        <DialogContent>
          <Box
            sx={{
              marginBottom: "15px",
              padding: 2,
              border: "1px solid #e6e1e1",
              borderRadius: "10px",
              borderTop: "3px solid #406682",
              boxShadow: "0 0 2px grey",
              backgroundColor: "white",
              //...paperstyles
            }}
          >
            <Typography variant="h6">
              <span
                style={{
                  background:
                    "linear-gradient(-90deg, #89bcdf 10%, #406882 90%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: "bold",
                }}
              >
                Job Title:
              </span>
              {` ${selectedJob?.jobtitle}`}
            </Typography>
          </Box>

          <Box
            sx={{
              padding: 2,
              //border: "1px solid #e6e1e1",
              borderRadius: "10px",
              // borderTop: "3px solid #406682",
              // boxShadow: "0 0 2px grey",
              backgroundColor: "white",
              //...paperstyles
            }}
          >
            <Typography
              variant="h6"
              sx={{
                background: "linear-gradient(-90deg, #89bcdf 10%, #406882 90%)",
                backgroundClip: "text",
                textFillColor: "transparent",
                fontWeight: "bold",
              }}
            >
              Job Description
            </Typography>
            <Typography paragraph>
              {selectedJob?.job_description !== null &&
                selectedJob?.job_description !== undefined &&
                selectedJob?.job_description
                ? !selectedJob?.job_description.includes("ahref") &&
                  !selectedJob?.job_description.includes("divclass") &&
                  !selectedJob?.job_description.includes("aclass") &&
                  !selectedJob?.job_description.includes("pclass") &&
                  !selectedJob?.job_description.includes("liclass")
                  ? parse(selectedJob?.job_description)
                  : selectedJob?.job_description.replace(/<[^>]+>/g, "")
                : ""}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
